import { useQuery } from "@tanstack/react-query";

import { useAccessToken } from "../use-access-token";
import { callLcosService } from "../../data/lcosServices";
import { CentersList } from "./types";

export const useCenters = () => {
  const { getToken } = useAccessToken();

  const getCentersData = async () => {
    return getCentersList(await getToken());
  };

  const centersQuery = useQuery({ queryKey: ["centersData"], queryFn: getCentersData });

  return {
    centers: centersQuery.data?.centers,
    isLoading: centersQuery.isLoading
  };
};

export const getCentersList = (accessToken: string) => {
  return callLcosService<CentersList>(accessToken, "/api/centers");
};
